import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { COMPANY } from "../data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#050a11] text-white">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-white/10 pb-16">
        <div className="md:col-span-6">
          <p className="overline text-white/40 mb-6">Let's build together</p>
          <h2 className="font-display font-light text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-xl">
            Ready to source smarter?
          </h2>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="group mt-10 inline-flex items-center gap-3 border border-white/25 rounded-full pl-6 pr-5 py-3 hover:bg-white hover:text-[#0b2046] transition-[background-color,color]"
          >
            <span className="font-medium">Contact our team</span>
            <ArrowUpRight size={18} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-5">Office</p>
          <address className="not-italic text-white/70 leading-relaxed text-sm space-y-0.5">
            {COMPANY.addressLines.map((l, i) => (
              <div key={i}>{l}</div>
            ))}
          </address>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-5">Reach us</p>
          <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="block text-white/70 hover:text-white text-sm link-sweep w-fit">
            {COMPANY.email}
          </a>
          <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="block mt-2 text-white/70 hover:text-white text-sm link-sweep w-fit">
            {COMPANY.phone}
          </a>
          <div className="flex gap-4 mt-6">
            {["Home", "About", "Services", "Contact"].map((n) => (
              <Link key={n} to={n === "Home" ? "/" : `/${n.toLowerCase()}`} className="overline text-white/40 hover:text-white transition-colors">
                {n}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 text-white/40">
        <span className="font-mono-x text-xs">© {new Date().getFullYear()} {COMPANY.legal}</span>
        <span className="font-mono-x text-xs tracking-widest">{COMPANY.ssm}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
